module.exports = __webpack_public_path__ + "static/media/humpty.7bfb067b.png";